import { isReference, type Bound } from '../../format/pieces';
import { isIsoDate } from 'framework/utils/hooks/useDateService';

export interface Note {
  text: string;
  error: boolean;
}

export type Entry = { kind: 'empty' } | { kind: 'bound'; bound: Bound } | { kind: 'unfinished' };

const EMPTY: Entry = { kind: 'empty' };
const UNFINISHED: Entry = { kind: 'unfinished' };
const bound = (value: Bound): Entry => ({ kind: 'bound', bound: value });

export const countEntry = (text: string): Entry => {
  return text === '' ? EMPTY : bound(Number(text));
};

export const dateEntry = (text: string): Entry => {
  if (text === '') return EMPTY;
  return isIsoDate(text) && text >= FIRST_FOUR_DIGIT_YEAR ? bound(text) : UNFINISHED;
};

const FIRST_FOUR_DIGIT_YEAR = '1000-01-01';

export const inWrongOrder = (min: Bound | undefined, max: Bound | undefined): boolean => {
  if (min === undefined || max === undefined || isReference(min) || isReference(max)) return false;
  return typeof min === typeof max && min > max;
};
